import {Province} from '@/model/src/values/dv-10';
import {YesNoChoice} from '@/model/src/values/dv-3';
import {Plans} from '@/model/src/values/dv-9';
import {ContractTypes} from '@/model/src/values/dv-93';
import {Condition, Event} from '@/model/types';
import {Contributor} from '../src/values/dv-11';
import {ParticipantOrExSpouse} from '../src/values/dv-12';
import {LegislationProvince} from '../src/values/dv-13';
import {Guarantees} from '../src/values/dv-88';
import {batchUnset} from './actions/fields';
import {Conditions} from './conditions';
import {and} from './conditions/utils';
import {isNewContract} from './section-a';

export const isPlan = <TPlan extends Plans>(plan: TPlan, useRefSyntax = false) => {
  const ref = useRefSyntax ? {$ref: plan} : plan;
  return Conditions.fields.isEqual('C1', ref);
};

export const isPlanIn = (...plans: Plans[]) => Conditions.fields.isIn('C1', plans);

export const isInQuebec = Conditions.fields.eq('C2', Province.QUEBEC);

export const isOutsideQuebec = Conditions.fields.eq('C2', Province.REST_OF_CANADA);

export const isLegislationProvinceIn = <TProvince extends LegislationProvince>(...provinces: TProvince[]) =>
  Conditions.fields.isIn('C3', provinces);

export const isContractholder = Conditions.fields.eq('C4', Contributor.CONTRACTHOLDER);

export const isSpousal = Conditions.fields.eq('C4', Contributor.SPOUSAL);

export const isExSpouse = Conditions.fields.eq('C5', ParticipantOrExSpouse.EX_SPOUSE);

export const isParticipant = Conditions.fields.eq('C5', ParticipantOrExSpouse.PARTICIPANT);

export const hasLimitedTradingAuthorization = Conditions.fields.eq('C6', YesNoChoice.YES);

export const hasNotLimitedTradingAuthorization = Conditions.fields.eq('C6', YesNoChoice.NO);

export const hasCoContractholder = Conditions.fields.eq('C9', YesNoChoice.YES);

export const isContractType = <TContractType extends ContractTypes>(type: TContractType) =>
  Conditions.fields.eq('C14', type);

export const isContractTypeIn = (...types: ContractTypes[]) => Conditions.fields.isIn('C14', types);

export const isGuaranteeIn = (...guarantees: Guarantees[]) => Conditions.fields.isIn('C13', guarantees);

export const isFRV_FRR_FRVR = Conditions.fields.isIn('C1', [Plans.RIF, Plans.LIF, Plans.RLIF]);

export const isNewFhsaContract: Condition = and(isNewContract, isPlan(Plans.FHSA));

export const hasAlreadyOpenedFhsa: Condition = Conditions.fields.eq('C20', YesNoChoice.YES);

export const clearFHSARequirementsFields = batchUnset(['C17', 'C18', 'C19', 'C20']) satisfies Event[];
